module.exports = __webpack_public_path__ + "img/prk.9c534291.svg";